import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var UcWordsPipe = (function () {
    function UcWordsPipe() {
    }
    UcWordsPipe.prototype.transform = function (text) {
        if (isString(text)) {
            return text.split(' ')
                .map(function (sub) { return sub.slice(0, 1).toUpperCase() + sub.slice(1); })
                .join(' ');
        }
        return text;
    };
    UcWordsPipe.decorators = [
        { type: Pipe, args: [{ name: 'ucwords' },] },
    ];
    /** @nocollapse */
    UcWordsPipe.ctorParameters = function () { return []; };
    return UcWordsPipe;
}());
export { UcWordsPipe };
//# sourceMappingURL=ucwords.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/ucwords.js
// module id = 294
// module chunks = 4